import dotenv from 'dotenv';
function nOrEarlier(choices, n) {
    const len = choices.length;
    if (n >= len) {
        return choices[len - 1];
    }
    else {
        return choices[n];
    }
}
export function selectAppEnv(choices) {
    if (process.env.REACT_APP_ENV === 'production') {
        return nOrEarlier(choices, 0);
    }
    else if (process.env.REACT_APP_ENV === 'staging') {
        return nOrEarlier(choices, 1);
    }
    else {
        return nOrEarlier(choices, 2);
    }
}
export const assertEnvironmentVariables = (variables) => {
    dotenv.config();
    let missingVariables = [];
    variables.forEach((variable) => {
        if (!process.env[variable]) {
            missingVariables = missingVariables.concat(variable);
        }
    });
    if (missingVariables.length) {
        if (missingVariables.length === 1) {
            throw new Error('Missing environment variable ' + missingVariables[0]);
        }
        throw new Error('Missing environment variables ' + missingVariables.join(', '));
    }
};
//# sourceMappingURL=environment.js.map